import he from 'he';
import { PRIVACY_POLICY, TERMS_AND_CONDITION } from './constant';

export const Toast = ({ msg }) => <>{msg}</>;
export const capitalizeAll = (s) => {
    if (typeof s !== 'string') return '';
    return s
        .toLowerCase()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};

export const getTenantId = () => localStorage.getItem('tenantId');

export const checkFileValidation = (files) => {
    let message =
        'The uploaded file is not a valid file type. Only .doc, .docx, .pdf, .csv, .xls and .xlsx file types are allowed.';
    const fileTypes = [
        'text/csv', // CSV
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // XLSX
        'application/pdf', // PDF
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // DOCX
        'application/msword', // DOC
        'application/vnd.ms-excel', //XLS
    ];
    if (files && fileTypes.includes(files?.type)) {
        return {
            status: true,
            msg: '',
        };
    } else {
        return {
            status: false,
            msg: message,
        };
    }
};
export const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(remainingSeconds).padStart(2, '0');
    return `${formattedMinutes}:${formattedSeconds}`;
};
export const generateUrl = (urlMode) => {
    const envMode = process.env.REACT_APP_ENV;
    let frontendUrlPreFix, backendUrlPreFix, socketUrlPrefix, externalUrl;
    let finalUrl;
    if (envMode === 'prod') {
        frontendUrlPreFix = '';
        backendUrlPreFix = 'api.';
        socketUrlPrefix = '';
        externalUrl = 'https://prod-in2.100ms.live/hmsapi/incruiter-prod.app.100ms.live/';
    } else if (envMode === 'test' || envMode === 'preprod') {
        frontendUrlPreFix = 'test.v1.';
        backendUrlPreFix = 'test.api.';
        socketUrlPrefix = 'test-';
        externalUrl = 'https://prod-in2.100ms.live/hmsapi/incruiter-preprod-bot-room.app.100ms.live/';
    } else if (envMode === 'dev2') {
        frontendUrlPreFix = 'dev.v2.';
        backendUrlPreFix = 'dev.v2.api.';
        socketUrlPrefix = 'dev2-';
        externalUrl = 'https://prod-in2.100ms.live/hmsapi/incruiter-dev-meet.app.100ms.live/';
    } else {
        frontendUrlPreFix = 'dev.v1.';
        backendUrlPreFix = 'dev.api.';
        socketUrlPrefix = 'dev-';
        externalUrl = 'https://prod-in2.100ms.live/hmsapi/incruiter-dev-meet.app.100ms.live/';
    }
    if (urlMode === 'token_generation') {
        finalUrl = externalUrl;
    } else if (urlMode === 'whiteboard') {
        finalUrl = `https://whiteboard.incruiter.com`;
    } else if (urlMode === 'socket') {
        finalUrl = `https://${socketUrlPrefix}video-feedback-system.incruiter.com`;
    } else if (urlMode === 'proctoring') {
        finalUrl = `https://${socketUrlPrefix}proctoring.incruiter.com`;
    } else if (urlMode === 'feed_backend') {
        finalUrl = `https://${backendUrlPreFix}incruiter.com/interview-system/api/v1/extension`;
    } else if (urlMode === 'interview_backend') {
        finalUrl = `https://${backendUrlPreFix}incruiter.com/interview-system/api/v1/incbot`;
    } else if (urlMode === 'interview_backend_url') {
        finalUrl = `https://${backendUrlPreFix}incruiter.com/interview-system/api/v1`;
    } else if (urlMode === 'pusher_backend') {
        finalUrl = `https://${backendUrlPreFix}incruiter.com/video-feedback-system/api/v1/video-platform/pusher`;
    } else if (urlMode === 'video_backend') {
        finalUrl = `https://${backendUrlPreFix}incruiter.com/video-feedback-system/api/v1/video-platform`;
    } else if (urlMode === 'meet_backend') {
        finalUrl = `https://${backendUrlPreFix}incruiter.com/video-feedback-system/api/v1/meet`;
    } else if (urlMode === 'skills_backend') {
        finalUrl = `https://${backendUrlPreFix}incruiter.com/skills-system/api/v1/list/skills`;
    } else if (urlMode === 'skill_backend') {
        finalUrl = `https://${backendUrlPreFix}incruiter.com/skills-system/api/v1/skills`;
    } else if (urlMode === 'meeting') {
        finalUrl = `https://${frontendUrlPreFix}video.incruiter.com`;
    } else if (urlMode === 'user_backend') {
        finalUrl = `https://${backendUrlPreFix}incruiter.com/user-auth-system/api/v1`;
    } else if (urlMode === PRIVACY_POLICY) {
        finalUrl = `https://${frontendUrlPreFix}incruiter.com/privacy-policy`;
    } else if (urlMode === TERMS_AND_CONDITION) {
        finalUrl = `https://${frontendUrlPreFix}incruiter.com/terms-and-condition`;
    } else if (urlMode === 'siemensPolicy') {
        finalUrl = `https://${frontendUrlPreFix}incruiter.com/siemens-privacy-notice`;
    } else if (urlMode === 'file-saver-system') {
        finalUrl = `https://${backendUrlPreFix}incruiter.com/file-saver-system/api/v1/fileSave`;
    } else if (urlMode === 'extraction') {
        finalUrl = `https://${backendUrlPreFix}incruiter.com/proctoring-ms`;
    } else if (urlMode === 'account') {
        finalUrl = `https://${frontendUrlPreFix}account.incruiter.com`;
    } else if (urlMode === 'csat_backend') {
        // For CSAT, use incserve service with environment-based prefix
        if (envMode === 'prod') {
            finalUrl = 'https://incserve.incruiter.com/api';
        } else if (envMode === 'test' || envMode === 'preprod') {
            finalUrl = 'https://test.incserve.incruiter.com/api';
        } else {
            finalUrl = 'https://dev.incserve.incruiter.com/api';
        }
    } else if (urlMode === 'ai_services_backend') {
        finalUrl = `https://${backendUrlPreFix}incruiter.com/ai-services-ms/api`;
    } else if (urlMode === 'frontend_base') {
        finalUrl = `https://${frontendUrlPreFix}incruiter.com`;
    }
    return finalUrl;
};

export const otherSkillsData = [
    {
        title: 'Soft Skills',
        skills: [
            {
                name: 'Confidence',
                skillType: 'soft',
                options: [
                    'Inadequate Confidence',
                    'Low Self-Assurance',
                    'Mildly Confident',
                    'Bold & Confident',
                    'Extremely Confident',
                ],
            },
            {
                name: 'Communication',
                skillType: 'soft',
                options: [
                    'Inadequate',
                    'Poor',
                    'Avg. Communication',
                    'Decent Communication',
                    'Excellent Communication',
                ],
            },
            {
                name: 'Pressure Handling',
                skillType: 'soft',
                options: ['Inefficient', 'Vulnerable', 'Moderate', 'Capable', 'Competent'],
            },
        ],
    },
    {
        title: 'Analytical Skills',
        skills: [
            {
                name: 'Approach & Attitude',
                skillType: 'analytics',
                options: ['Extremely Low', 'Poor', 'Moderate', 'Positive', 'Extremely Positive'],
            },
            {
                name: 'Problem Solving',
                skillType: 'analytics',
                options: ['Extremely Low', 'Substandard', 'Moderate', 'Problem Solver', 'Excellent'],
            },
            {
                name: 'Result Oriented',
                skillType: 'analytics',
                options: ['Extremely Low', 'Lacks Focus', 'Passable', 'Highly Enthusiastic', 'Goal Driven'],
            },
        ],
    },
    {
        title: 'Leadership/managerial Skills (for 10+ years)',
        skills: [
            {
                name: 'Decision Making',
                skillType: 'leadership',
                options: ['Bad Decision Maker', 'Dysfunctional', 'Moderate', 'Quite Decisive', 'Extremely Decisive'],
            },
            {
                name: 'Team Management',
                skillType: 'leadership',
                options: [
                    'Extremely Lousy',
                    'Poor Admin. & Control',
                    'Decent Synergism',
                    'People Manager',
                    'Highly Efficient',
                ],
            },
            {
                name: 'Accountability',
                skillType: 'leadership',
                options: [
                    'Extremely Unaccountable',
                    'Low Accountability',
                    'Somewhat Accountable',
                    'Answerable',
                    'Extremely Reliable',
                ],
            },
        ],
    },
];

const DEFAULT_ERROR_MSG = 'Something went wrong. Please try again.';
const generateError = (msg) => ({ status: false, msg });

export const validateFile = async ({
    file,
    maxSizeMB = 5,
    allowedTypes = [],
    endpoint = '',
    emptyMsg = 'File is empty or undefined',
    sizeMsg = 'The file size exceeds the limit',
    typeMsg = 'Invalid file type',
    fallbackMsg = 'Invalid file. Please upload a valid file',
}) => {
    try {
        if (!file) return generateError(emptyMsg);
        if (file.size > maxSizeMB * 1024 * 1024) return generateError(sizeMsg);
        const allowedTypesArray = Array.isArray(allowedTypes)
            ? allowedTypes
            : allowedTypes.split(',').map((type) => type.trim());

        if (!allowedTypesArray.includes(file.type)) return generateError(typeMsg);

        const formData = new FormData();
        formData.append('file', file);

        const url = `${generateUrl('interview_backend_url')}/${endpoint}`;
        const response = await fetch(url, { method: 'POST', body: formData });
        const res = await response.json();

        return {
            status: res?.status ?? false,
            msg: res?.message || fallbackMsg,
        };
    } catch {
        return generateError(DEFAULT_ERROR_MSG);
    }
};

export const FILE_TYPES = {
    IMAGE: 'image/jpeg, image/png, image/jpg',
    ZIP: 'zip, application/octet-stream, application/zip, application/x-zip, application/x-zip-compressed',
    XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    PDF_WORD_XLSX: [
        'application/pdf',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
        'application/msword', // .doc
        'application/x-msword',
        'application/x-cfb',
        'application/vnd.ms-word.document.macroenabled.12',
        'text/csv', // CSV
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // XLSX
        'application/vnd.ms-excel', //XLS
    ].join(', '),
};

export const checkImageBlank = (file) =>
    validateFile({
        file,
        maxSizeMB: 5,
        allowedTypes: FILE_TYPES.IMAGE,
        endpoint: 'validateImage',
        emptyMsg: 'Image is empty or undefined',
        sizeMsg: 'The image size exceeds the 5MB limit',
        typeMsg: 'Invalid image type. Only .jpg, .jpeg, and .png are allowed.',
        fallbackMsg: 'Invalid image type. Please upload a valid image',
    });

export const checkMultiFileBlank = (file) =>
    validateFile({
        file,
        maxSizeMB: 25,
        allowedTypes: FILE_TYPES.PDF_WORD_XLSX,
        endpoint: 'validateMultiFile',
        emptyMsg: 'File is empty or undefined',
        sizeMsg: 'The file size exceeds the 25MB limit',
        typeMsg: 'Invalid file type. Only .doc, .docx, .pdf, .csv, .xls and .xlsx are allowed.',
        fallbackMsg: 'Invalid file type. Please upload a valid file',
    });

export const isValidDataURI = (dataURI) => {
    return dataURI && dataURI.length > 10 && !dataURI.includes('png');
};

export const decodeHTML = (str) => {
    const decodedText = he.decode(str);
    const entityMap = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#039;': "'",
    };
    return decodedText.replace(/&(?:amp|lt|gt|quot|#039);/g, (match) => entityMap[match]);
};

export const getMaxKeyName = (items) => {
    if (!items || typeof items !== 'object') return null;
    const maxKey = Object.keys(items).reduce((max, current) => (items[current] > items[max] ? current : max));
    const name = maxKey.charAt(0).toUpperCase() + maxKey.slice(1);
    return { key: maxKey, name };
};

export const getPercentageOfOnes = (arr, index) => {
    if (!Array.isArray(arr) || typeof index !== 'number' || index < 0) {
        throw new Error('Invalid input');
    }
    const subArray = arr.slice(0, index);
    const total = subArray.length;
    if (total === 0) return 0;
    const countOnes = subArray.reduce((sum, val) => sum + (val === 1 ? 1 : 0), 0);
    return Math.round((countOnes / total) * 100);
};

export const candidateChartMetric = (analytics, timings) => {
    const arrayMetric = [];

    timings.forEach((timing, index) => {
        const analysis = analytics?.candidateAnalysis?.[timing] || {};
        const eye_contact = getPercentageOfOnes(analytics?.candidateEyeContact, index + 1) / 100;
        const clarity_score = analytics?.candidate?.summary?.[0]?.score || 0;
        const happy = analysis?.facial?.happy || 0;
        const surprise = analysis?.facial?.surprise || 0;
        const fear = analysis?.facial?.fear || 0;
        const sad = analysis?.facial?.sad || 0;
        const sentiment = analysis?.sentiment || {};
        const sentimentNeutral = sentiment?.neutral || 0;
        const sentimentPositive = sentiment?.positive || 0;
        const sentimentNegative = sentiment?.negative || 0;
        const speakingRateScore = analysis?.speaking_rate_score || 0;
        const speakingRate = (speakingRateScore / 10).toFixed(2);

        const tmpData = {
            time: formatTime(timing),
            Confidence: (
                0.5 * eye_contact +
                0.3 * (speakingRateScore / 10) +
                0.1 * (happy + surprise) +
                0.1 * (1 - fear - sad)
            ).toFixed(2),
            'Communication Clarity': (
                0.3 * (clarity_score / 10) +
                0.4 * (sentimentNeutral + sentimentPositive) +
                0.3 * (speakingRateScore / 10)
            ).toFixed(2),
            'Stress/Nervousness': (0.5 * (fear + sad) + 0.5 * sentimentNegative).toFixed(2),
            'Speaking Rate': speakingRate,
        };

        arrayMetric.push(tmpData);
    });

    return arrayMetric;
};

export const interviewerChartMetric = (analytics, timings) => {
    const arrayMetric = [];

    timings.forEach((timing, index) => {
        const analysis = analytics?.interviewerAnalysis?.[timing] || {};
        const eye_contact = getPercentageOfOnes(analytics?.interviewerEyeContact, index + 1) / 100;
        const drowsiness = getPercentageOfOnes(analytics?.interviewerDrowsiness, index + 1) / 100;
        const happy = analysis?.facial?.happy || 0;
        const surprise = analysis?.facial?.surprise || 0;
        const fear = analysis?.facial?.fear || 0;
        const sad = analysis?.facial?.sad || 0;
        const angry = analysis?.facial?.angry || 0;
        const disgust = analysis?.facial?.disgust || 0;
        const neutral = analysis?.facial?.neutral || 0;
        const sentiment = analysis?.sentiment || {};
        const sentimentPositive = sentiment?.positive || 0;

        const tmpData = {
            time: formatTime(timing),
            Attentiveness: (0.5 * eye_contact + 0.3 * (1 - drowsiness) + 0.2 * (1 - (angry + fear + sad)) || 0).toFixed(
                2
            ),
            Engagement: (0.6 * sentimentPositive + 0.2 * happy + 0.2 * surprise || 0).toFixed(2),
            Composure: (1 - (angry + fear + sad + disgust) || 0).toFixed(2),
            'Energy Level': (0.3 * surprise + 0.7 * (1 - drowsiness) || 0).toFixed(2),
            'Emotional Balance': ((neutral + happy) / (neutral + happy + angry + fear + sad) || 0).toFixed(2),
        };

        arrayMetric.push(tmpData);
    });

    return arrayMetric;
};

export const isMobileOrTabletDevice = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    return (
        /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|tablet/.test(userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    ); // iPadOS detection
};

export const isMobileDevice = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    return (
        /android|webos|iphone|ipod|blackberry|iemobile|opera mini/.test(userAgent) &&
        !(navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    ); // Exclude iPadOS
};

export const calculateHeight = (value, viewportHeight) => {
    const difference = viewportHeight - (viewportHeight * (100 - value)) / 100;
    return `${difference}px`;
};

export const styles = {
    menu: (provided) => ({
        ...provided,
        zIndex: 9999,
        background: '#2B3045',
        width: '100%',
    }),

    listbox: (provided) => ({
        ...provided,
        padding: 0,
    }),

    option: (provided) => ({
        ...provided,
        color: '#FFF',
        fontSize: '12px',
        background: '#2B3045',
        border: '1px solid white',
        textAlign: 'center',
    }),

    control: (provided, state) => ({
        ...provided,
        minHeight: '30px',
        height: '30px',
        background: 'transparent',
        opacity: state.isDisabled ? 0.5 : 1,
        cursor: state.isDisabled ? 'not-allowed' : 'default',
    }),

    valueContainer: (provided) => ({
        ...provided,
        padding: '0 8px',
    }),

    indicatorsContainer: (provided) => ({
        ...provided,
        padding: '4px 8px',
        height: '30px',
    }),

    indicatorSeparator: () => ({
        display: 'none', // optional: cleaner look
    }),

    dropdownIndicator: (provided, state) => ({
        ...provided,
        padding: 0,
        opacity: state.isDisabled ? 0.5 : 1,
    }),

    clearIndicator: (provided, state) => ({
        ...provided,
        padding: 0,
        opacity: state.isDisabled ? 0.5 : 1,
    }),
};
